/**
 * These strings are used for the app param of the endpoint, do not change if not needed.
 * https://leaseplan-digital.atlassian.net/wiki/spaces/NGRMT/pages/4303290385/Sitecore+endpoints#Environment-API-endpoint-format
 */
export enum SCBrand {
  Ayvens = 'NGB',
  NFFleet = 'NFFleet',
}
